<template>
  <div class="contenido">
    <h2>{{ father }} | Libreta</h2>
    <v-dialog v-model="dialog" content-class="reporte">
      <v-card>
        <v-card-title class="grey lighten-4 py-4 title">
          Libreta de Calificación
          <v-layout justify-end>
            <v-flex shrink>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    class="iconoDescargar fas fa-file-pdf"
                    @click="descargarPDF(infoCursoSeleccionado.descripcion)"
                    >mdi-file-pdf</v-icon
                  >
                </template>
                <span>Descargar Planilla PDF</span>
              </v-tooltip>
            </v-flex>
            <v-flex shrink>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    class="iconoDescargar fas fa-file-excel"
                    @click="descargarXLS"
                  ></v-icon>
                </template>
                <span>Descargar Planilla Excel</span>
              </v-tooltip>
            </v-flex>
          </v-layout>
        </v-card-title>
        <template v-if="materiasAlumnoSeleccinado.length > 0">
          <v-layout class="align-center">
            <v-flex xs12>
              <v-layout class="align-center cabecera">
                <v-flex xs2 class="text-xs-center">ALUMNO:</v-flex>
                <v-flex xs2 class="text-xs-center">{{
                  alumnoSeleccionado
                }}</v-flex>
                <v-flex xs2 class="text-xs-center">AGRUPAMIENTO/CURSO:</v-flex>
                <v-flex xs2 class="text-xs-center">{{
                  infoCursoSeleccionado.descripcion
                }}</v-flex>
                <v-flex xs2 class="text-xs-center">Nivel:</v-flex>
              </v-layout>
              <div class="cuerpo">
                <v-layout>
                  <v-flex xs2 class="text-xs-center">ESPACIO CURRICULAR</v-flex>
                  <template
                    v-for="(nota, nota_index) in materiasAlumnoSeleccinado[0]
                      .notas"
                  >
                    <v-flex :key="nota_index" xs1 class="text-xs-center"
                      >{{ nota_index + 1 }}° T</v-flex
                    >
                  </template>
                  <v-flex xs1 class="text-xs-center">Prom.</v-flex>
                </v-layout>
                <template v-for="(materia, index) in materiasAlumnoSeleccinado">
                  <v-layout :key="index">
                    <v-flex xs2 class="fila">{{
                      mayusculas(materia.nombre)
                    }}</v-flex>
                    <template v-for="(nota, nota_index) in materia.notas">
                      <v-flex
                        :key="nota_index"
                        xs1
                        class="fila text-xs-center"
                        >{{
                          nota.nota != 0 &&
                          nota.nota != null &&
                          nota.nota != "-"
                            ? formatearNota(nota.nota)
                            : ""
                        }}</v-flex
                      >
                    </template>
                    <v-flex xs1 class="fila text-xs-center">{{
                      calcularPromedio(materia.notas)
                    }}</v-flex>
                  </v-layout>
                </template>
              </div>
            </v-flex>
          </v-layout>
        </template>
      </v-card>
    </v-dialog>
    <v-layout>
      <v-flex xs12>
        <v-layout align-center justify-center>
          <v-flex shrink>
            <v-select
              v-model="cursoSeleccionado"
              ref="cursoList"
              :items="cursos"
              item-text="descripcion"
              item-value="id"
              label="Cursos"
              @change="obtenerNotasCursos()"
            ></v-select>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <template v-if="alumnos.length > 0">
      <v-layout class="align-center">
        <v-flex xs9 class="text-xs-center">
          <v-layout>
            <v-flex xs6>
              <h2>Alumno</h2>
            </v-flex>
          </v-layout>
        </v-flex>
        <!--<template v-for="(materia, index_mat) in materias">
          <v-flex xs2 class="text-xs-center" :key="index_mat">{{mayusculas(materia.nombre)}}</v-flex>
        </template>-->
      </v-layout>
      <template v-for="(alumno, index) in alumnos">
        <!--<alumno :alumno="alumno" :key="index" />-->
        <v-layout :key="index" align-center justify-center>
          <v-flex xs9>
            <v-layout>
              <v-flex xs6 class="fila">{{ alumno.nombre }}</v-flex>
              <v-flex xs1 class="fila">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" @click="mostrarLibreta(alumno)"
                      >mdi-eye</v-icon
                    >
                  </template>
                  <span>Ver Libreta</span>
                </v-tooltip>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </template>
    </template>
  </div>
</template>


<script>
import API from "@/components/_config/conf";
//import construccion from "../componentesGenerales/a_construccion";

export default {
  data() {
    return {
      dialog: false,
      cursoSeleccionado: "",
      infoCursoSeleccionado: "",
      materiasAlumnoSeleccinado: [],
      alumnoSeleccionado: "",
      idAlumnoSeleccionado: "",
      materias: [],
      cursos: [],
      alumnos: [],
    };
  },
  props: ["father"],
  components: {
    //construccion
  },
  mounted: function () {
    let resultado = API.enviar("get", "obtenerCursos", "");

    resultado
      .then((result) => {
        //console.log(result);
        if (result.data.msj == "ok") this.cursos = result.data.result;
        //this.materiasCant = result.data.length;
      })
      .catch(() => {
        //console.log("catch obtenerMateriasDeProfesor-> params: ", params);
      });
  },
  methods: {
    mayusculas: function (string) {
      let string_aux = API.ucFirst(string);
      return string_aux;
    },
    formatearNota: function (nota) {
      //console.log(nota);
      let notaAux = parseFloat(nota);
      notaAux = notaAux.toFixed(2);
      return notaAux;
    },
    obtenerNotasCursos: function () {
      this.$emit("libreta:mostrarOcultarPreload");

      let params = "idAgrupamiento=" + this.cursoSeleccionado;
      let resultado = API.enviar("get", "obtenerNotasTrimestres", params);

      resultado
        .then((result) => {
          if (result.data.msj == "ok") {
            this.alumnos = result.data.result;
            //this.materias = result.data.result[0].materias;
            /*console.log(
              "obtenerNotasTrimestres OK: ",
              result.data.result,
              result.data.result[0].materias
            );*/
            this.$emit("libreta:mostrarOcultarPreload");
          } else {
            this.$emit("libreta:mostrarOcultarPreload");
          }
          //this.$emit("reporteGralGrilla:mostrarOcultarPreload");
          //this.dialog = true;
        })
        .catch(() => {
          //console.log("catch obtenerMateriasDeProfesor-> params: ", params);
        });
    },
    descargarPDF: function (agrupamiento) {
      console.log(
        this.idAlumnoSeleccionado,
        this.cursoSeleccionado,
        agrupamiento
      );
      let local = window.localStorage.getItem("EPA_AUTH");
      let localJson = JSON.parse(local);
      let token = localJson.token;

      window.open(
        process.env.VUE_APP_API +
          API.PATH +
          "?funcion=descargarLibretaPDF&idAgrupamiento=" +
          this.cursoSeleccionado +
          "&idAlumno=" +
          this.idAlumnoSeleccionado +
          "&agrupamiento=" +
          agrupamiento +
          "&token=" +
          token
      );
    },
    descargarXLS: function (agrupamiento) {
      console.log(
        this.idAlumnoSeleccionado,
        this.cursoSeleccionado,
        agrupamiento
      );
      let local = window.localStorage.getItem("EPA_AUTH");
      let localJson = JSON.parse(local);
      let token = localJson.token;

      window.open(
        API.PORT +
          API.PATH +
          "?funcion=descargarLibretaXLS&idAgrupamiento=" +
          this.cursoSeleccionado +
          "&idAlumno=" +
          this.idAlumnoSeleccionado +
          "&agrupamiento=" +
          agrupamiento +
          "&token=" +
          token
      );
    },
    setInfoCurso: function (cursoAux) {
      //console.log(this.infoCursoSeleccionado, cursoAux);
      if (cursoAux.id == this.cursoSeleccionado)
        this.infoCursoSeleccionado = cursoAux;
    },
    mostrarLibreta: function (alumno) {
      /*console.log(
        "curso: ",
        //this.cursos[this.cursoSeleccionado - 1].descripcion,
        this.cursos,
        this.cursoSeleccionado
      );*/

      var cursosAux = this.cursos;

      cursosAux.forEach((element) => {
        this.setInfoCurso(element);
      });

      //console.log(this.infoCursoSeleccionado);

      this.idAlumnoSeleccionado = alumno.idAlumno;
      this.alumnoSeleccionado = alumno.nombre;
      this.materiasAlumnoSeleccinado = alumno.materias;
      this.dialog = true;
      console.log(
        this.idAlumnoSeleccionado,
        this.alumnoSeleccionado,
        this.materiasAlumnoSeleccinado
      );
    },
    calcularPromedio: function (notas) {
      var promedio = 0;
      let cantidadNotas = 0;

      for (const nota in notas) {
        let notaAux = notas[nota].nota;
        //console.log("nota: ", notaAux);

        if (notaAux != 0 && notaAux != null && notaAux != "-") {
          cantidadNotas = cantidadNotas + 1;
          promedio = parseFloat(promedio) + parseFloat(notaAux);
        } else {
          cantidadNotas = cantidadNotas + 1;
        }
      }
      //console.log("val: ", promedio, cantidadNotas);
      if (cantidadNotas > 0 && promedio > 0) {
        promedio = parseFloat(promedio / cantidadNotas);
        promedio = promedio.toFixed(2);
      } else promedio = "";

      /*console.log("->", promedio);
      console.log("-----------------------");*/
      return promedio;
    },
  },
};
</script>

<style>
.contenido {
  width: 100% !important;
}

h2 {
  padding: 10px;
}

.libretaIcono {
  padding-left: 12px;
}

.cabecera {
  padding: 15px 15px 15px 15px;
  border: solid 2px #000 !important;
}

.cuerpo {
  padding: 10px;
  border: solid 2px #000;
}

.fila {
  border-bottom: solid 1px #ccc;
  padding: 5px 0 5px 0;
}

.columna {
  border-right: solid 1px #000;
}

.iconoDescargar {
  padding-right: 10px;
}
</style>